//  This is a generated file, do not edit it directly
import SvgIcon from '@mui/material/SvgIcon';
import type { TpBaseSvgIconProps } from '../types/muiSvgIcon';
import { SvgChevronLeft } from '../icons/ChevronLeft';

export function ChevronLeftIcon(props: TpBaseSvgIconProps): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgChevronLeft} data-qa="ChevronLeftIcon">
      <svg />
    </SvgIcon>
  );
}
